import classNames from "classnames"

import treePng from "../../../assets/img/record/tree.png"
import treeWebP from "../../../assets/img/record/tree.webp"
import styles from "./index.module.less"

interface Props {
    position: "left" | "right"
    className?: string
    style?: React.CSSProperties
}

const Tree: React.FC<Props> = (props) => {
    const { position, className, style } = props

    return (
        <div
            className={classNames(styles.tree, styles[position], className)}
            style={style}
        >
            <picture>
                <source srcSet={treeWebP} type="image/webp" />
                <img src={treePng} alt="tree" />
            </picture>
        </div>
    )
}

export default Tree
